import React, { useState } from "react";
import { toast } from "sonner";
import { DownloadSimple, FileCsv, FilePdf } from "@phosphor-icons/react";
import { formatApiError } from "../../../lib/api";
import { downloadCsv } from "./iaUtils";

const CSVS = [["periods", "Period table"], ["customers", "Customer table"], ["srs", "Raw · Service requests"],
  ["invoices", "Raw · Invoices"], ["payments", "Raw · Payments"], ["health", "Raw · Health records"]];

export function ExportMenu({ f, group, onBranded, onPlain }) {
  const [open, setOpen] = useState(false);
  const [pdfStep, setPdfStep] = useState(false);
  const [busy, setBusy] = useState(false);
  const run = async (fn) => {
    setBusy(true);
    try { await fn(); setOpen(false); setPdfStep(false); } catch (e) { toast.error(formatApiError(e)); }
    setBusy(false);
  };
  const item = "w-full text-left px-3 py-2 text-xs hover:bg-[#F7F6F2] flex items-center gap-2 disabled:opacity-50";
  return (
    <div className="relative">
      <button onClick={() => { setOpen(o => !o); setPdfStep(false); }} data-testid="ia-export"
              className="h-10 px-4 rounded-md bg-[#1A1A1A] hover:bg-black text-white text-sm font-medium inline-flex items-center gap-2">
        <DownloadSimple size={14}/>{busy ? "Preparing…" : "Export"}
      </button>
      {open && (
        <div className="absolute right-0 mt-1 w-64 bg-white border border-[#E5E2D9] rounded-md shadow-xl z-40 py-1" data-testid="ia-export-menu">
          {!pdfStep ? (
            <>
              <div className="px-3 pt-1 pb-1 text-[10px] uppercase tracking-[0.18em] text-[#8A8780]">CSV (current filters)</div>
              {CSVS.map(([k, l]) => (
                <button key={k} disabled={busy} className={item} data-testid={`ia-export-csv-${k}`}
                        onClick={() => run(() => downloadCsv(k, f, group))}><FileCsv size={13}/>{l}</button>
              ))}
              <div className="border-t border-[#F0EDE4] my-1"/>
              <button className={item} onClick={() => setPdfStep(true)} data-testid="ia-export-pdf"><FilePdf size={13}/>PDF…</button>
            </>
          ) : (
            <>
              <div className="px-3 pt-1 pb-1 text-[10px] uppercase tracking-[0.18em] text-[#8A8780]">Choose PDF style</div>
              <button disabled={busy} className={item} data-testid="ia-export-pdf-branded" onClick={() => run(onBranded)}>
                <FilePdf size={13} className="text-[#D23247]"/>Branded management report</button>
              <button disabled={busy} className={item} data-testid="ia-export-pdf-plain-periods" onClick={() => run(() => onPlain("periods"))}>
                <FilePdf size={13}/>Plain table · Period table</button>
              <button disabled={busy} className={item} data-testid="ia-export-pdf-plain-customers" onClick={() => run(() => onPlain("customers"))}>
                <FilePdf size={13}/>Plain table · Customer table</button>
            </>
          )}
        </div>
      )}
    </div>
  );
}
